/* eslint-disable */
import * as yup from 'yup'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  File: { input: File; output: File; }
  /** Mongo object id scalar type */
  UUID: { input: string; output: string; }
};

/** Object representing authentication. */
export type Authentication = {
  __typename?: 'Authentication';
  /** The authentication created at. */
  createdAt: Scalars['DateTimeISO']['output'];
  /** The authentication UUID */
  id: Scalars['String']['output'];
  /** The authentication token. */
  token: Scalars['String']['output'];
  /** The authentication user. */
  user: User;
};

export type CreateProductInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pictures?: InputMaybe<Array<Scalars['String']['input']>>;
  price: Scalars['Float']['input'];
  sku: Scalars['String']['input'];
  status: Scalars['String']['input'];
  stock?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LogInInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addPicture?: Maybe<Picture>;
  addProduct: Product;
  addUser: User;
  deletePicture?: Maybe<Picture>;
  deleteProduct: Product;
  deleteUser: User;
  logIn: Authentication;
  signIn: Authentication;
  updateProduct: Product;
  updateUser: User;
};


export type MutationAddPictureArgs = {
  file: Scalars['File']['input'];
};


export type MutationAddProductArgs = {
  product: CreateProductInput;
};


export type MutationAddUserArgs = {
  user: CreateUserInput;
};


export type MutationDeletePictureArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationLogInArgs = {
  input: LogInInput;
};


export type MutationSignInArgs = {
  input: SignInInput;
};


export type MutationUpdateProductArgs = {
  product: UpdateProductInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserInput;
};

/** Object representing page info. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The page info end cursor. */
  endCursor: Scalars['String']['output'];
  /** Is there next page. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Is there previous page. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The page info start cursor. */
  startCursor: Scalars['String']['output'];
};

/** Object representing product. */
export type Picture = {
  __typename?: 'Picture';
  /** The product UUID */
  id: Scalars['String']['output'];
  /** The picture's name. */
  name: Scalars['String']['output'];
  /** The picture's product. */
  product?: Maybe<Product>;
  /** The picture's thumbnail. */
  thumbnail: Scalars['String']['output'];
  /** The picture's url. */
  url: Scalars['String']['output'];
  /** The authentication user. */
  user: User;
};

/** Object representing product connection. */
export type PictureConnection = {
  __typename?: 'PictureConnection';
  /** The pictures connection edge. */
  edges: Array<PictureEdge>;
  /** The pictures connection page info. */
  pageInfo: PageInfo;
};

/** Object representing product edge. */
export type PictureEdge = {
  __typename?: 'PictureEdge';
  /** The edge cursor. */
  cursor: Scalars['String']['output'];
  /** The edge node. */
  node: Picture;
};

/** Object representing product. */
export type Product = {
  __typename?: 'Product';
  /** The product's category. */
  category: Scalars['String']['output'];
  /** The product's SKU. */
  description: Scalars['String']['output'];
  /** The product's UUID */
  id?: Maybe<Scalars['String']['output']>;
  /** The product's name. */
  name: Scalars['String']['output'];
  /** The product's pictures. */
  pictures: PictureConnection;
  /** The product's price. */
  price: Scalars['Float']['output'];
  /** The product's rating. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** The product's SKU. */
  sku: Scalars['String']['output'];
  /** The product's status. */
  status: ProductStatus;
  /** The product's stock. */
  stock?: Maybe<Scalars['Float']['output']>;
  /** The product's created at date. */
  updatedAt: Scalars['DateTimeISO']['output'];
  /** The product's user. */
  user: User;
  /** The product's weight. */
  weight?: Maybe<Scalars['Float']['output']>;
};


/** Object representing product. */
export type ProductPicturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
};

/** Object representing product connection. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** The products connection edge. */
  edges: Array<ProductEdge>;
  /** The products connection page info. */
  pageInfo: PageInfo;
};

/** Object representing product edge. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** The edge cursor. */
  cursor: Scalars['String']['output'];
  /** The edge node. */
  node: Product;
};

/** The product's status. */
export enum ProductStatus {
  Active = 'Active',
  Draft = 'Draft',
  Inactive = 'Inactive',
  OutOfStock = 'OutOfStock'
}

export type ProductsOrderInput = {
  price?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  authentication?: Maybe<Authentication>;
  picture?: Maybe<Picture>;
  /** Get all the pictures from shop. */
  pictures: PictureConnection;
  product?: Maybe<Product>;
  /** Get all the products from shop. */
  products: ProductConnection;
  user?: Maybe<User>;
  /** Get all the users from shop. */
  users: Array<User>;
};


export type QueryAuthenticationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPictureArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPicturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<ProductsOrderInput>;
};


export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

/** The user roles. */
export enum Roles {
  Admin = 'Admin',
  User = 'User'
}

export type SignInInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UpdateProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserInput = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Object representing user. */
export type User = {
  __typename?: 'User';
  /** The user created at. */
  createdAt: Scalars['DateTimeISO']['output'];
  /** The user email. */
  email: Scalars['String']['output'];
  /** The user UUID */
  id: Scalars['String']['output'];
  /** The user name. */
  name: Scalars['String']['output'];
  /** The user roles. */
  roles: Array<Roles>;
  /** The user updated at. */
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AddPictureMutationVariables = Exact<{
  file: Scalars['File']['input'];
}>;


export type AddPictureMutation = { __typename?: 'Mutation', addPicture?: (
    { __typename?: 'Picture' }
    & { ' $fragmentRefs'?: { 'PictureItemFragment': PictureItemFragment } }
  ) | null };

export type AddProductMutationVariables = Exact<{
  product: CreateProductInput;
}>;


export type AddProductMutation = { __typename?: 'Mutation', addProduct: (
    { __typename?: 'Product' }
    & { ' $fragmentRefs'?: { 'ProductItemFragment': ProductItemFragment } }
  ) };

export type DeletePictureMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeletePictureMutation = { __typename?: 'Mutation', deletePicture?: (
    { __typename?: 'Picture' }
    & { ' $fragmentRefs'?: { 'PictureItemFragment': PictureItemFragment } }
  ) | null };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: { __typename?: 'Product', id?: string | null } };

export type PictureItemFragment = { __typename?: 'Picture', id: string, name: string, url: string, thumbnail: string, product?: { __typename?: 'Product', id?: string | null } | null } & { ' $fragmentName'?: 'PictureItemFragment' };

export type GetProductQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product?: (
    { __typename?: 'Product' }
    & { ' $fragmentRefs'?: { 'ProductItemFragment': ProductItemFragment } }
  ) | null };

export type ProductFormFragment = { __typename?: 'Product', description: string, name: string, price: number, sku: string, stock?: number | null, weight?: number | null } & { ' $fragmentName'?: 'ProductFormFragment' };

export type ProductItemFragment = { __typename?: 'Product', description: string, id?: string | null, name: string, price: number, rating?: number | null, sku: string, status: ProductStatus, stock?: number | null, weight?: number | null, pictures: { __typename?: 'PictureConnection', edges: Array<{ __typename?: 'PictureEdge', node: (
        { __typename?: 'Picture' }
        & { ' $fragmentRefs'?: { 'PictureItemFragment': PictureItemFragment } }
      ) }> } } & { ' $fragmentName'?: 'ProductItemFragment' };

export type GetProductsQueryVariables = Exact<{
  first: Scalars['Float']['input'];
}>;


export type GetProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node: (
        { __typename?: 'Product', pictures: { __typename?: 'PictureConnection', edges: Array<{ __typename?: 'PictureEdge', node: (
              { __typename?: 'Picture' }
              & { ' $fragmentRefs'?: { 'PictureItemFragment': PictureItemFragment } }
            ) }> } }
        & { ' $fragmentRefs'?: { 'ProductItemFragment': ProductItemFragment } }
      ) }> } };

export type UpdateProductMutationVariables = Exact<{
  product: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: (
    { __typename?: 'Product', pictures: { __typename?: 'PictureConnection', edges: Array<{ __typename?: 'PictureEdge', node: (
          { __typename?: 'Picture' }
          & { ' $fragmentRefs'?: { 'PictureItemFragment': PictureItemFragment } }
        ) }> } }
    & { ' $fragmentRefs'?: { 'ProductItemFragment': ProductItemFragment } }
  ) };

export const ProductFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]} as unknown as DocumentNode<ProductFormFragment, unknown>;
export const PictureItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}}]} as unknown as DocumentNode<PictureItemFragment, unknown>;
export const ProductItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}}]} as unknown as DocumentNode<ProductItemFragment, unknown>;
export const AddPictureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addPicture"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPicture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}}]} as unknown as DocumentNode<AddPictureMutation, AddPictureMutationVariables>;
export const AddProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]} as unknown as DocumentNode<AddProductMutation, AddProductMutationVariables>;
export const DeletePictureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePicture"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePicture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}}]} as unknown as DocumentNode<DeletePictureMutation, DeletePictureMutationVariables>;
export const DeleteProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProductMutation, DeleteProductMutationVariables>;
export const GetProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]} as unknown as DocumentNode<GetProductQuery, GetProductQueryVariables>;
export const GetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductItem"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const UpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductItem"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PictureItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picture"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PictureItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;

export const ProductStatusSchema = yup.string<ProductStatus>().oneOf(Object.values(ProductStatus)).defined();

export const RolesSchema = yup.string<Roles>().oneOf(Object.values(Roles)).defined();

export function CreateProductInputSchema(): yup.ObjectSchema<CreateProductInput> {
  return yup.object({
    category: yup.string().defined().nullable().optional(),
    description: yup.string().defined().nonNullable(),
    name: yup.string().defined().nonNullable(),
    pictures: yup.array(yup.string().defined().nonNullable()).defined().nullable().optional(),
    price: yup.number().defined().nonNullable(),
    sku: yup.string().defined().nonNullable(),
    status: yup.string().defined().nonNullable(),
    stock: yup.number().defined().nullable().optional(),
    weight: yup.number().defined().nullable().optional()
  })
}

export function CreateUserInputSchema(): yup.ObjectSchema<CreateUserInput> {
  return yup.object({
    email: yup.string().defined().nonNullable(),
    name: yup.string().defined().nonNullable(),
    password: yup.string().defined().nonNullable()
  })
}

export function LogInInputSchema(): yup.ObjectSchema<LogInInput> {
  return yup.object({
    email: yup.string().defined().nonNullable(),
    password: yup.string().defined().nonNullable()
  })
}

export function ProductsOrderInputSchema(): yup.ObjectSchema<ProductsOrderInput> {
  return yup.object({
    price: yup.string().defined().nullable().optional(),
    rating: yup.string().defined().nullable().optional(),
    updatedAt: yup.string().defined().nullable().optional()
  })
}

export function SignInInputSchema(): yup.ObjectSchema<SignInInput> {
  return yup.object({
    email: yup.string().defined().nonNullable(),
    name: yup.string().defined().nonNullable(),
    password: yup.string().defined().nonNullable()
  })
}

export function UpdateProductInputSchema(): yup.ObjectSchema<UpdateProductInput> {
  return yup.object({
    description: yup.string().defined().nullable().optional(),
    id: yup.string().defined().nonNullable(),
    name: yup.string().defined().nullable().optional(),
    pictures: yup.array(yup.string().defined().nonNullable()).defined().nullable().optional(),
    price: yup.number().defined().nullable().optional(),
    sku: yup.string().defined().nullable().optional(),
    status: yup.string().defined().nullable().optional(),
    stock: yup.number().defined().nullable().optional(),
    weight: yup.number().defined().nullable().optional()
  })
}

export function UpdateUserInputSchema(): yup.ObjectSchema<UpdateUserInput> {
  return yup.object({
    email: yup.string().defined().nonNullable(),
    id: yup.string().defined().nonNullable(),
    name: yup.string().defined().nonNullable(),
    password: yup.string().defined().nonNullable()
  })
}
